import bowlImage from './lamb.png';
import kibble from './kibble.png';

export const image = {
  ollie: { src: bowlImage, alt: 'bowl', width: 250, height: 250 },
  kibbleImage: {
    src: kibble,
    alt: 'kibble',
    width: 250,
    height: 250,
  },
};

export const breakPoints = [
  {
    width: 1,
    itemsToShow: 1,
  },
  {
    width: 668,
    itemsToShow: 2,
    pagination: false,
    showArrows: false,
    showDots: false,
  },
];
